export enum TaskQuickFilter {
  MY_TASKS = 'myTasks',
  MY_DEPARTMENT_TASKS = 'myDepartmentTasks',
  DUE_TODAY = 'dueToday',
  RESERVATION_TASKS = 'reservationTasks',
  ROOM_TASKS = 'roomTasks'
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/domain/enums/TaskQuickFilter.ts